import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getInteractiontypeIcon',
})
export class GetInteractiontypeIconPipe implements PipeTransform {
  transform(interactiontypeId: number | null | undefined): string {
    switch (interactiontypeId) {
      case 1:
        return 'sticky_note_2';
      case 2:
        return 'person';
      case 3:
        return 'task_alt';
      default: {
        return 'sticky_note_2';
      }
    }
  }
}
